export const CARRIER_DEFAULT_HOME = '#/loads'
